"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SET_SEND_TIMEOUT = void 0;
exports["default"] = setSendTimeout;
var SET_SEND_TIMEOUT = 'WEB_CHAT/SET_SEND_TIMEOUT';
exports.SET_SEND_TIMEOUT = SET_SEND_TIMEOUT;

function setSendTimeout(sendTimeout) {
  return {
    type: SET_SEND_TIMEOUT,
    payload: {
      sendTimeout: sendTimeout
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTRVRfU0VORF9USU1FT1VUIiwic2V0U2VuZFRpbWVvdXQiLCJzZW5kVGltZW91dCIsInR5cGUiLCJwYXlsb2FkIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FjdGlvbnMvc2V0U2VuZFRpbWVvdXQuanMiXSwic291cmNlc0NvbnRlbnQiOlsiY29uc3QgU0VUX1NFTkRfVElNRU9VVCA9ICdXRUJfQ0hBVC9TRVRfU0VORF9USU1FT1VUJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc2V0U2VuZFRpbWVvdXQoc2VuZFRpbWVvdXQpIHtcbiAgcmV0dXJuIHtcbiAgICB0eXBlOiBTRVRfU0VORF9USU1FT1VULFxuICAgIHBheWxvYWQ6IHsgc2VuZFRpbWVvdXQgfVxuICB9O1xufVxuXG5leHBvcnQgeyBTRVRfU0VORF9USU1FT1VUIH07XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSxnQkFBZ0IsR0FBRywyQkFBekI7OztBQUVlLFNBQVNDLGNBQVQsQ0FBd0JDLFdBQXhCLEVBQXFDO0VBQ2xELE9BQU87SUFDTEMsSUFBSSxFQUFFSCxnQkFERDtJQUVMSSxPQUFPLEVBQUU7TUFBRUYsV0FBVyxFQUFYQTtJQUFGO0VBRkosQ0FBUDtBQUlEIn0=